import { Controller } from "@hotwired/stimulus"

// Pick an existing subscriber-space user (sets user_id / person_id), type the id of an existing
// account, search one in the users index, or reveal nested "new person" fields. Disables hidden
// nested inputs so they are not submitted: posting user_attributes[id] alongside a re-pointed
// user_id raises RecordNotFound.
export default class extends Controller {
  static targets = ["choice", "associationId", "newFields", "manualFields", "searchFields", "searchId", "card"]

  connect() {
    this.sync()
  }

  change() {
    this.sync()
  }

  sync() {
    const selected = this.choiceTargets.find((input) => input.checked)
    const value = selected?.value
    const manual = value === "manual"
    const search = value === "search"
    const creatingNew = !manual && !search && (value === "new" || value === "" || value == null)

    if (this.hasAssociationIdTarget) {
      // Manual mode owns the field: keep whatever the operator typed.
      if (!manual && !search) {
        this.associationIdTarget.value = creatingNew ? "" : value
      }
      // Search mode: the relation-selector buttons own it; re-read the picked row when coming back.
      if (search) {
        const picked = this.pickedButton()
        if (picked) this.associationIdTarget.value = picked.dataset.parentId
        if (this.hasSearchIdTarget && picked) this.searchIdTarget.value = picked.dataset.parentId
      }
      this.associationIdTarget.disabled = creatingNew
    }

    if (this.hasManualFieldsTarget) {
      this.manualFieldsTarget.classList.toggle("d-none", !manual)
    }

    if (this.hasSearchFieldsTarget) {
      this.searchFieldsTarget.classList.toggle("d-none", !search)
      this.searchFieldsTarget.querySelectorAll("input, select, textarea").forEach((el) => {
        el.disabled = !search
      })
    }

    // Nested panes: outline the card of the current choice.
    this.cardTargets.forEach((card) => {
      const active = card.dataset.choice === value || (card.dataset.choice === "new" && creatingNew)
      card.classList.toggle("border-dark", active)
    })

    if (this.hasNewFieldsTarget) {
      this.newFieldsTarget.classList.toggle("d-none", !creatingNew)
      this.newFieldsTarget.querySelectorAll("input, select, textarea").forEach((el) => {
        el.disabled = !creatingNew
      })
    }
  }

  // Admin id typed in the search pane: it becomes the association, and no row stays highlighted.
  typeSearchId(event) {
    if (!this.hasAssociationIdTarget) return
    const id = event.target.value.trim()
    this.associationIdTarget.value = id
    const picked = this.pickedButton()
    if (picked && picked.dataset.parentId !== id) {
      this.application.getControllerForElementAndIdentifier(this.element, "relation-selector")?.updateButtons(null)
    }
  }

  // A row picked in the index (relation-selector handles the click first): mirror it in the id field.
  reflectPick(event) {
    if (!this.hasSearchIdTarget || !event.target.closest("[data-relation-selector-target='button']")) return
    setTimeout(() => { this.searchIdTarget.value = this.pickedButton()?.dataset.parentId || "" })
  }

  pickedButton() {
    return this.element.querySelector("[data-relation-selector-target='button'].btn-outline-danger")
  }
}
